/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react'
import {
  Card,
  FlexView,
  Table,
  Button,
  Spinner,
  Modal,
  Link,
} from '../components/common'
import { StockContext } from 'stores/StockStore'
import { AppContext } from '../stores/AppStore'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import _ from 'lodash'
import { UserContext } from 'stores/UserStore'
import { RiFileExcel2Line } from 'react-icons/ri'
import { FaRegFilePdf } from 'react-icons/fa'
import { IoArrowBackOutline } from 'react-icons/io5'
import { BsLayoutTextSidebar } from 'react-icons/bs'
import { formatIppnFull } from 'utils/format'

const Stock = () => {
  const history = useHistory()
  const { setPageSubtitle } = useContext(AppContext)
  const { registryLog } = useContext(UserContext)
  const {
    tableDetailsData,
    tableTotalPieces,
    isLoadingTable,
    exportToPdf,
    exportToExcel,
  } = useContext(StockContext)
  const { t } = useTranslation()
  const [showColumns, setShowColumns] = useState({
    ippn: true,
    client: true,
    contract: true,
    center: true,
    warehouse: true,
    sot: true,
    sotRelated: true,
    nmIncoming: true,
    nmIncomingDescription: true,
    nmActual: true,
    nmActualDescription: true,
    invoice: true,
    invoiceDate: true,
    incomingDate: true,
    incomingReservation: true,
    returnReservation: true,
    qtyIncoming: true,
    qty: true,
    status: true,
    statusMaterialDate: true,
    localWarehouse: true,
  })
  const [isOpen, setOpen] = useState(false)
  const DEFAULT_URL = 'services-stock/details'

  const columns = [
    {
      Header: t('service.tableIppn'),
      accessor: (row) => (
        <Link onClick={() => onLinkSelect('ippn/' + row.ippn)}>
          {' '}
          {formatIppnFull(row.ippn)}
        </Link>
      ),
      id: 'ippn',
    },
    {
      Header: t('service.tableClient'),
      accessor: 'client',
      id: 'client',
    },
    {
      Header: t('service.tableContract'),
      accessor: 'contract',
      id: 'contract',
    },
    {
      Header: t('service.tableCenter'),
      accessor: 'center',
      id: 'center',
    },
    {
      Header: t('service.tableWarehouse'),
      accessor: 'warehouse',
      id: 'warehouse',
    },
    {
      Header: t('service.tableSot'),
      accessor: (row) => (
        <Link onClick={() => onLinkSelect('sot/' + row.sot)}> {row.sot}</Link>
      ),
      id: 'sot',
    },
    {
      Header: t('service.tableSotRelated'),
      accessor: 'sotRelated',
      id: 'sotRelated',
    },
    {
      Header: t('service.tableNmIncoming'),
      accessor: 'nmIncoming',
      id: 'nmIncoming',
    },
    {
      Header: t('service.tableNmIncomingDescription'),
      accessor: 'nmIncomingDescription',
      id: 'nmIncomingDescription',
    },
    {
      Header: t('service.tableInvoice'),
      accessor: (row) => (
        <Link onClick={() => onLinkSelect('invoice/' + row.invoice)}>
          {' '}
          {row.invoice}
        </Link>
      ),
      id: 'invoice',
    },
    {
      Header: t('service.tableInvoiceDate'),
      id: 'invoiceDate',
      accessor: (row) => moment(row.invoiceDate).format('DD/MM/YYYY'),
    },
    {
      Header: t('service.tableIncomingDate'),
      id: 'incomingDate',
      accessor: (row) => moment(row.incomingDate).format('DD/MM/YYYY'),
    },
    {
      Header: t('service.tableIncomingReservation'),
      accessor: 'incomingReservation',
      id: 'incomingReservation',
    },
    {
      Header: t('service.tableReturnReservation'),
      accessor: 'returnReservation',
      id: 'returnReservation',
    },
    {
      Header: t('service.tableQtyIncoming'),
      accessor: (row) => parseInt(row.qtyIncoming),
      id: 'qtyIncoming',
    },
    {
      Header: t('service.tableQty'),
      accessor: (row) => parseInt(row.qty),
      id: 'qty',
    },
    {
      Header: t('service.tableNmActual'),
      accessor: 'nmActual',
      id: 'nmActual',
    },
    {
      Header: t('service.tableNmActualDescription'),
      accessor: 'nmActualDescription',
      id: 'nmActualDescription',
    },
    {
      Header: t('service.tableStatus'),
      accessor: (row) => t('service.tableStatus' + row.status),
      id: 'status',
    },
    {
      Header: t('service.tableStatusMaterialDate'),
      accessor: (row) => moment(row.statusMaterialDate).format('DD/MM/YYYY'),
      id: 'statusMaterialDate',
    },
    {
      Header: t('service.tableLocalWarehouse'),
      accessor: 'localWarehouse',
      id: 'localWarehouse',
    }
  ]

  const columnModal = [
    {
      Header: t('service.tableDetailsField'),
      accessor: 'item',
      id: 'item',
    },
    {
      Header: t('service.tableDetailsDescription'),
      accessor: 'description',
      id: 'description',
    },
  ]

  const dataModal = [
    {
      item: t('service.tableIppn'),
      description: t('service.descriptionIppn'),
    },
    {
      item: t('service.tableClient'),
      description: t('service.descriptionClient'),
    },
    {
      item: t('service.tableContract'),
      description: t('service.descriptionContract'),
    },
    {
      item: t('service.tableCenter'),
      description: t('service.descriptionCenter'),
    },
    {
      item: t('service.tableWarehouse'),
      description: t('service.descriptionWarehouse'),
    },
    {
      item: t('service.tableSot'),
      description: t('service.descriptionSot'),
    },
    {
      item: t('service.tableSotRelated'),
      description: t('service.descriptionSotRelated'),
    },
    {
      item: t('service.tableNmIncoming'),
      description: t('service.descriptionNmIncoming'),
    },
    {
      item: t('service.tableNmIncomingDescription'),
      description: t('service.NmIncomingDescription'),
    },
    {
      item: t('service.tableInvoice'),
      description: t('service.descriptionInvoice'),
    },
    {
      item: t('service.tableInvoiceDate'),
      description: t('service.descriptionInvoiceDate'),
    },
    {
      item: t('service.tableIncomingReservation'),
      description: t('service.descriptionIncomingReservation'),
    },
    {
      item: t('service.tableQtyIncoming'),
      description: t('service.descriptionQtyIncoming'),
    },
    {
      item: t('service.tableQty'),
      description: t('service.descriptionQty'),
    },
    {
      item: t('service.tableStatus'),
      description: t('service.descriptionStatus'),
    },
    {
      item: t('service.tableStatusMaterialDate'),
      description: t('service.descriptionStatusMaterialDate'),
    },
    {
      item: t('service.tableLocalWarehouse'),
      description: t('service.descriptionLocalWarehouse'),
    },
    {
      item: t('service.returnReservation'),
      description: t('service.descriptionReturnReservation'),
    },
  ]

  const onLinkSelect = (val) => {
    window.location.href = `https://tlh.${process.env.REACT_APP_DOMAIN}/` + val
  }

  const filteredColumns = _.filter(columns, (column) =>
    _.get(showColumns, column.id)
  )
  const toggleModal = () => {
    //registryLogOld('click_modalLegend', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'click', 'modal_legend')
    setOpen((current) => !current)
  }

  const onPdfExportClick = () => {
    //registryLogOld('click_exportPdf', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'click', 'export_pdf')
    exportToPdf(filteredColumns)
  }

  const onExcelExportClick = () => {
    //registryLogOld('click_exportExcel', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'click', 'export_excel')
    exportToExcel(filteredColumns)
  }

  useEffect(() => {
    setPageSubtitle(t('service.pageTitle'))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const back = () => {
    //registryLogOld('click_back', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'navigation', 'page_out')
    history.push('/')
  }

  return (
    <FlexView flex="1" backgroundColor="background" alignSelf="stretch">
      <FlexView
        alignSelf="stretch"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems={
          !(tableTotalPieces > 0) || isLoadingTable ? 'stretch' : 'flex-start'
        }
      >
        <FlexView
          margin="10px 16px 4px"
          flexDirection="row"
          justifyContent="space-between"
          alignSelf="stretch"
        >
          <FlexView>
            <IoArrowBackOutline
              style={{ width: '35px', height: '35px', color: '#777777', cursor: 'pointer' }}
              margin="0px 18px 0px 0px"
              onClick={() => back()}
            />
          </FlexView>
          <FlexView
            margin="0px 30px 0px"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
            flex="1"
          >
            <RiFileExcel2Line
              style={{ width: '35px', height: '35px', color: '#59CBE4', cursor: 'pointer' }}
              margin="0px 18px 0px 0px"
              onClick={() => onExcelExportClick()}
            />{' '}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <FaRegFilePdf
              style={{ width: '30px', height: '30px', color: '#6a5cff', cursor: 'pointer' }}
              margin="0px 18px 0px 0px"
              onClick={() => onPdfExportClick()}
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <BsLayoutTextSidebar
              style={{ width: '30px', height: '30px', color: '#59e480', cursor: 'pointer' }}
              margin="0px 18px 0px 0px"
              onClick={() => toggleModal()}
            />
          </FlexView>
        </FlexView>
        <Card
          borderRadius="24px"
          flexDirection="column"
          alignItems="stretch"
          fontSize="medium"
          padding="0px"
          width="calc(100% - 16px)"
          minHeight="400px"
        >
          {tableTotalPieces > 0 && (
            <FlexView
              margin="16px"
              alignSelf="center"
            >
              <FlexView
                fontSize="big"
                fontWeight="bold"
                alignItems="center"
                justifyContent="center"
                alignSelf="center"
              >
                {t('service.tableTitle')}
              </FlexView>
            </FlexView>
          )}
          {!tableTotalPieces > 0 ? (
            <FlexView
              flex="1"
              justifyContent="center"
              alignItems="center"
              padding="50px"
              fontSize="big"
              fontWeight="bold"
              color="gray"
              backgroundColor="transparent"
            >
              {isLoadingTable ? (
                <Spinner />
              ) : (
                <div>{t('service.tableNoData')}</div>
              )}
              <Button
                outline
                onClick={back}
                margin="32px 0px 0px"
                color={isLoadingTable ? 'primary' : undefined}
              >
                {t('service.buttonBack')}
              </Button>
            </FlexView>
          ) : (
            <Table
              width="100%"
              columns={filteredColumns}
              data={tableDetailsData}
              sortable
              elevation="none"
              borderRadius="card"
              paginated
              style={{ whiteSpace: 'nowrap' }}
            />
          )}
        </Card>

        <Modal isOpen={isOpen} onOutsideClick={toggleModal}>
          <Card
            flex="1"
            flexDirection="column"
            margin="0px 50px"
            padding="0px"
            alignItems="center"
            maxHeight="560px"
            style={{ overflow: 'auto' }}
          >
            <Table
              width="100%"
              margin="8px 0px 0px"
              columns={columnModal}
              data={dataModal}
              sortable
              elevation="none"
              borderRadius="card"
            />
          </Card>
        </Modal>
      </FlexView>
    </FlexView>
  )
}
export default Stock
